module.exports = __webpack_public_path__ + "static/img/penny.473936c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/haibao_h5/penny.jpg
// module id = S09F
// module chunks = 0